export enum DomainId {
  Amana = 'amana',
  Amica = 'amica',
  Ao = 'ao',
  Argos = 'argos',
  Baumatic = 'baumatic',
  Baxi = 'baxi',
  Beko = 'beko',
  Beko10YearPartsGuarantee = 'beko10',
  Beko2YearPartsGuarantee = 'beko2',
  Belling = 'belling',
  Blomberg = 'blomberg',
  Bosch = 'bosch',
  BoschStaffDiscount = 'bosch-staff',
  Bush = 'bush',
  Candy = 'candy',
  Candy2YearGuarantee = 'candy2',
  Cannon = 'cannon',
  Cda = 'cda',
  Comfee = 'comfee',
  Creda = 'creda',
  DomesticAndGeneral = 'domestic-and-general',
  Flavel = 'flavel',
  Grundig = 'grundig',
  Haier = 'haier',
  Hoover = 'hoover',
  Hoover2YearGuarantee = 'hoover2',
  Hotpoint = 'hotpoint',
  Indesit = 'indesit',
  JennAir = 'jennair',
  KitchenAid = 'kitchenaid',
  LEC = 'lec',
  Leisure = 'leisure',
  LG = 'lg',
  Matrix = 'matrix',
  Maytag = 'maytag',
  Miele = 'miele',
  MiraShowers = 'mira-showers',
  Neff = 'neff',
  Siemens = 'siemens',
  Smeg = 'Smeg',
  Stoves = 'stoves',
  Vaillant = 'vaillant',
  Whirlpool = 'whirlpool',
  Zenith = 'zenith',
}
